import { Injectable } from '@angular/core';
import { CorretorFacade } from '../facades/corretor.facade';

import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs';
import { LightboxesService } from '../components/lightboxes/lightboxes.service';

@Injectable({
  providedIn: 'root'
})
export class RouteAuthGuard  {
  private isAuthenticated: boolean = true;

  constructor(
    private corretorFacade: CorretorFacade,
    private lightboxesService:  LightboxesService,
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | boolean {
    window.scroll(0, 0);

    if(sessionStorage.getItem('token') === null) {
      this.corretorFacade.logout();

      window.setTimeout(() => {
        this.lightboxesService.open({
          title: 'Acesso expirado',
          text: 'Faça o login novamente.',
        }, 20_000)
      }, 600);

      return false;
    }
    else {
      return this.isAuthenticated;
    }
  }
}
